import { Outlet } from "react-router-dom";

import { Button } from "src/@/components/ui/button";
import { useAppSelector } from "src/redux/hooks";
import { getUser } from "src/redux/selectors";
import { useLogout } from "#hooks/use-logout";

export const MarketplaceLayout = () => {
    const user = useAppSelector(getUser);
    const logout = useLogout();
    const userIdentifier = user?.email || user?.number || "Unknown user";

    return (
        <div className="flex min-h-screen flex-col bg-muted/30 text-foreground">
            <header className="border-b bg-background">
                <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-4 px-6 py-4">
                    <div className="flex items-center gap-3">
                        <img
                            src="/snackpass-logo.svg"
                            alt="Snackpass"
                            className="h-8 w-auto"
                        />
                        <div>
                            <h1 className="text-base font-semibold">
                                Marketplace Onboarding
                            </h1>
                            <p className="text-sm text-muted-foreground">
                                Signed in as {userIdentifier}
                            </p>
                        </div>
                    </div>
                    <Button type="button" variant="outline" onClick={logout}>
                        Log out
                    </Button>
                </div>
            </header>
            <main className="flex flex-1">
                <Outlet />
            </main>
        </div>
    );
};
